module.exports = __webpack_public_path__ + "img/3ccf69e1ade7db592f3f5fa0447ce646.png";